// extracted by mini-css-extract-plugin
export default {"upcoming_visit":"style_upcoming_visit__Fku7d","name":"style_name__gn1rO","add_btn":"style_add_btn__-t2ix","date":"style_date__NtToK"};